import createReducer from '../createReducer';
import {
  SET_SWELL_HEIGHT_COLORS,
  SET_SWELL_HEIGHT_ARROW_OPTIONS,
  OVERWRITE_CHART_CONFIG,
  SET_SWELL_HEIGHT_PARTICLE_OPTIONS,
} from '../../actions/charts';

// Swell height values are encoded in the tile sets as METERS.
// This scale should be passed into the SDK for basic color styling.
// Any conversion to other units should only take place on the legend
const scale = [
  { value: 0, color: [13, 30, 149] },
  { value: 0.61, color: [29, 64, 245] },
  { value: 1.22, color: [28, 114, 247] },
  { value: 1.83, color: [26, 157, 249] },
  { value: 2.44, color: [35, 202, 250] },
  { value: 3.05, color: [43, 252, 204] },
  { value: 3.66, color: [42, 250, 159] },
  { value: 4.27, color: [41, 247, 101] },
  { value: 4.88, color: [144, 249, 74] },
  { value: 5.49, color: [202, 250, 77] },
  { value: 6.1, color: [252, 248, 79] },
  { value: 6.71, color: [253, 171, 58] },
  { value: 7.32, color: [253, 99, 41] },
  { value: 7.92, color: [253, 78, 38] },
  { value: 8.53, color: [252, 15, 32] },
  { value: 9.14, color: [186, 8, 20] },
  { value: 9.75, color: [148, 11, 13] },
  { value: 10.36, color: [119, 5, 59] },
  { value: 10.97, color: [139, 0, 77] },
  { value: 11.58, color: [157, 0, 98] },
  { value: 12.19, color: [174, 0, 122] },
  { value: 12.8, color: [187, 0, 150] },
  { value: 13.41, color: [198, 0, 181] },
  { value: 14.02, color: [203, 0, 215] },
  { value: 14.63, color: [202, 39, 252] },
];

export const initialState = {
  tileLayerOptions: {
    maxZoom: 6,
    minZoom: 1,
    renderTransparentArea: true,
  },
  gradientColoringFragmentOptions: {
    decode: {
      channel: 'r',
      min: 0,
      max: 16,
    },
    stops: scale,
    smooth: false,
    opacity: 1.0,
  },
  particleOptions: {
    decodeAsWaves: true,
    decodeChannels: 'rg',
    decodeMin: 0,
    decodeMax: 1,
    color: [255, 255, 255, 60],
    size: 1,
    drawAsLines: true,
    speed: 0.001,
    maxAmount: 128,
    density: 4,
    refreshInterval: 800,
    fadeFactor: 0.05,
  },
  arrowLayerOptions: {
    decodeChannels: 'gb',
    decodeMin: -4,
    decodeMax: 4,
    size: 10,
    speed: 0.00122,
    maxAmount: 128,
    density: 4,
    refreshInterval: 1385,
    color: [255, 255, 255, 120],
    rttTimestep: 70,
    worldSpaceConstant: false,
    speedWeightedByVectorNorm: false,
    scaleSize: {
      decodeChannels: 'r',
      decodeMin: 0,
      decodeMax: 16,
      arrowMinSize: 5,
    },
  },
};

const handlers = {
  [SET_SWELL_HEIGHT_COLORS]: (state, { colors }) => ({
    ...state,
    gradientColoringFragmentOptions: {
      ...state.gradientColoringFragmentOptions,
      stops: colors,
    },
  }),
  [SET_SWELL_HEIGHT_ARROW_OPTIONS]: (state, { options }) => ({
    ...state,
    arrowLayerOptions: {
      ...state.arrowLayerOptions,
      ...options,
    },
  }),
  [SET_SWELL_HEIGHT_PARTICLE_OPTIONS]: (state, { options }) => ({
    ...state,
    particleOptions: {
      ...state.particleOptions,
      ...options,
    },
  }),
  [OVERWRITE_CHART_CONFIG]: (_, { config }) => ({
    ...config.swell,
  }),
};

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/charts/swell.js